import bugsnag from './bugsnag';
import sentry from './sentry';

export default {
  bugsnag,
  sentry,
};
